import apiClient from '@/services/rest-api-identity/apiClient'

const baseEndpoint = '/api/oauth/token'

export const updateFcm = async (data) => {
  const response = await apiClient({
    method: 'PATCH',
    url: `${baseEndpoint}/update-fcm`,
    data,
  })

  return response?.data
}
